<template>
  <v-container fluid>
    <v-progress-linear v-if="loadingWorkDocx" indeterminate />
    <v-container>
      <v-card class="elevation-0">
        <v-card-title>Готовность заключения (Представления о ЛП)</v-card-title>
        <v-card-text v-if="loadingWorkDocx">
          <v-skeleton-loader
            type="list-item-two-line, list-item-two-line, list-item-two-line"
          />
        </v-card-text>
        <v-card-text v-else>
          <v-expansion-panels class="my-2" flat>
            <v-expansion-panel :readonly="!checkPresentation">
              <v-expansion-panel-header
                :style="
                  !checkPresentation ? 'cursor: default' : 'cursor: pointer'
                "
                :color="checkPresentation ? '#ecf4eb' : '#fdf2e7'"
                :expand-icon="checkPresentation ? 'mdi-chevron-down' : ''"
                class="py-0"
              >
                <template #actions
                  ><LastActionDialog
                    v-if="isManager && !checkPresentation"
                    :value="objSummary"
                  >
                    <template #content="{ value }">
                      <SummaryForLog :value="value" readonly />
                    </template> </LastActionDialog
                ></template>
                <v-row
                  :style="
                    checkPresentation ? 'color: #5d9e52' : 'color: #ec9235'
                  "
                  class="exp_header_text ml-8"
                  ><v-icon
                    :style="
                      checkPresentation ? 'color: #5d9e52' : 'color: #ec9235'
                    "
                    class="exp_icon"
                    >mdi-numeric-1</v-icon
                  >
                  <span>{{ getPresentation }}</span>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content eager>
                <SummaryForLog
                  v-if="checkPresentation"
                  :value="expertise.summary"
                />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <v-expansion-panels class="my-2" flat>
            <v-expansion-panel :readonly="!checkRefPricing">
              <v-expansion-panel-header
                :style="
                  !checkRefPricing ? 'cursor: default' : 'cursor: pointer'
                "
                :color="checkRefPricing ? '#ecf4eb' : '#fdf2e7'"
                :expand-icon="checkRefPricing ? 'mdi-chevron-down' : 'mdi-eye'"
                class="py-0"
              >
                <template #actions>
                  <LastActionDialog
                    v-if="isManager && !checkRefPricing"
                    :value="objRef"
                  >
                    <template #content="{ value }">
                      <RefPricing :value="value" readonly />
                    </template>
                  </LastActionDialog>
                </template>
                <v-row
                  :style="checkRefPricing ? 'color: #5d9e52' : 'color: #ec9235'"
                  class="exp_header_text ml-8 mr-10"
                  ><v-icon
                    :style="
                      checkRefPricing ? 'color: #5d9e52' : 'color: #ec9235'
                    "
                    class="exp_icon"
                    >mdi-numeric-2</v-icon
                  >
                  <span>{{ getPricing }}</span>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content eager>
                <RefPricing
                  v-if="checkRefPricing"
                  :value="expertise.ref"
                  readonly
                />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <v-expansion-panels class="my-2" flat>
            <v-expansion-panel :readonly="!checkCost">
              <v-expansion-panel-header
                :style="!checkCost ? 'cursor: default' : 'cursor: pointer'"
                :color="checkCost ? '#ecf4eb' : '#fdf2e7'"
                :expand-icon="checkCost ? 'mdi-chevron-down' : ''"
                class="py-0"
              >
                <template #actions
                  ><LastActionDialog
                    v-if="isManager && !checkCost"
                    :value="objCost"
                  >
                    <template #content="{ value }">
                      <CostCalc :value="value" readonly />
                    </template> </LastActionDialog
                ></template>
                <v-row
                  :style="checkCost ? 'color: #5d9e52' : 'color: #ec9235'"
                  class="exp_header_text ml-8"
                  ><v-icon
                    :style="checkCost ? 'color: #5d9e52' : 'color: #ec9235'"
                    class="exp_icon"
                    >mdi-numeric-3</v-icon
                  >
                  <span>{{ getCost }}</span>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content eager>
                <CostCalc v-if="checkCost" :value="expertise.cost" log-view />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <v-expansion-panels class="my-2" flat>
            <v-expansion-panel :readonly="!checkAgencies">
              <v-expansion-panel-header
                :style="!checkAgencies ? 'cursor: default' : 'cursor: pointer'"
                :color="checkAgencies ? '#ecf4eb' : '#fdf2e7'"
                :expand-icon="checkAgencies ? 'mdi-chevron-down' : ''"
                class="py-0"
              >
                <template #actions
                  ><LastActionDialog
                    v-if="isManager && !checkAgencies"
                    :value="objAgencies"
                  >
                    <template #content="{ value }">
                      <ExpAgency :value="value" readonly />
                    </template> </LastActionDialog
                ></template>
                <v-row
                  :style="checkAgencies ? 'color: #5d9e52' : 'color: #ec9235'"
                  class="exp_header_text ml-8"
                  ><v-icon
                    :style="checkAgencies ? 'color: #5d9e52' : 'color: #ec9235'"
                    class="exp_icon"
                    >mdi-numeric-4</v-icon
                  >
                  <span>{{ getAgencies }}</span>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content eager>
                <ExpAgency
                  v-if="checkAgencies"
                  :value="expertise.agencies"
                  readonly
                />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <v-expansion-panels class="my-2" flat>
            <v-expansion-panel :readonly="!checkGoPricing">
              <v-expansion-panel-header
                :style="!checkGoPricing ? 'cursor: default' : 'cursor: pointer'"
                :color="checkGoPricing ? '#ecf4eb' : '#fdf2e7'"
                :expand-icon="checkGoPricing ? 'mdi-chevron-down' : ''"
                class="py-0"
              >
                <template #actions
                  ><LastActionDialog
                    v-if="isManager && !checkGoPricing"
                    :value="objGoPricing"
                  >
                    <template #content="{ value }">
                      <GoPricingCalc :value="value" readonly log-view />
                    </template> </LastActionDialog
                ></template>
                <v-row
                  :style="checkGoPricing ? 'color: #5d9e52' : 'color: #ec9235'"
                  class="exp_header_text ml-8"
                  ><v-icon
                    :style="
                      checkGoPricing ? 'color: #5d9e52' : 'color: #ec9235'
                    "
                    class="exp_icon"
                    >mdi-numeric-5</v-icon
                  >
                  <span>{{ getGoPricing }}</span>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content eager>
                <GoPricingCalc
                  v-if="checkGoPricing"
                  :value="expertiseGoPricing"
                  readonly
                />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <v-expansion-panels class="my-2" flat>
            <v-expansion-panel :readonly="!checkCommission">
              <v-expansion-panel-header
                :style="
                  !checkCommission ? 'cursor: default' : 'cursor: pointer'
                "
                :color="checkCommission ? '#ecf4eb' : '#fdf2e7'"
                :expand-icon="checkCommission ? 'mdi-chevron-down' : ''"
                class="py-0"
              >
                <template #actions
                  ><LastActionDialog
                    v-if="isManager && !checkCommission"
                    :value="objCommission"
                  >
                    <template #content="{ value }">
                      <ExpCommissionQuestions
                        :value="value"
                        readonly
                        log-view
                      />
                    </template> </LastActionDialog
                ></template>
                <v-row
                  :style="checkCommission ? 'color: #5d9e52' : 'color: #ec9235'"
                  class="exp_header_text ml-8"
                  ><v-icon
                    :style="
                      checkCommission ? 'color: #5d9e52' : 'color: #ec9235'
                    "
                    class="exp_icon"
                    >mdi-numeric-6</v-icon
                  >
                  <span>{{ getCommission }}</span>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content eager>
                <ExpCommissionQuestions
                  v-if="checkCommission"
                  :value="expertiseCommission"
                  readonly
                />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-divider />
          <v-card-actions class="text-right">
            <v-btn
              color="primary"
              :loading="downloadDocx"
              :disabled="!getProperties"
              @click="exportDocx"
              ><v-icon left> mdi-download </v-icon>
              Выгрузить представление о ЛП (.docx)
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-container>
  </v-container>
</template>

<script>
import { Document, Packer } from 'docx'
import { saveAs } from 'file-saver'
import { ensureDocxFileName } from '@/lib/strUtils'

import { mapActions, mapGetters, mapMutations } from 'vuex'
import { createOneChapter } from '@/components/reportPresentation/allChapter/oneChapter'
import { createTwoChapter } from '@/components/reportPresentation/allChapter/twoChapter'
import {
  landscapeSectionProps,
  portraitSectionProps,
} from '@/components/reportPresentation/presentationSectionProps'
import {
  createApplicantAdditionalChapter,
  createMkQualityChapter,
} from '@/components/reportPresentation/additionalChaptersDocx'
import {
  SUB_EX_ABOUT,
  SUB_EX_ASSESSMENT,
  SUB_EX_COMMISSION,
  SUB_EX_GO_PRICING,
  SUB_EX_OTHER,
  SUB_EXPERTISE_FOR_SUMMARY_REPORT,
} from '@/store/const/expertise'
import SummaryForLog from '@/components/expSummary/SummaryForLog'
import RefPricing from '@/components/expPricing/RefPricing'
import LastActionDialog from '@/components/viewLogs/LastActionDialog'
import CostCalc from '@/components/expCost/CostCalc'
import ExpAgency from '../expAgency/ExpAgency.vue'
import GoPricingCalc from '@/components/expGoPricing/GoPricingCalc'
import ExpCommissionQuestions from '@/components/expCommissionQuestions/ExpCommissionQuestions'
import { createThreeChapter } from '@/components/reportPresentation/allChapter/threeChapter'
import { createFourChapter } from '@/components/reportPresentation/allChapter/fourChapter'

export default {
  name: 'PresentationDocx',
  components: {
    CostCalc,
    LastActionDialog,
    RefPricing,
    ExpAgency,
    SummaryForLog,
    GoPricingCalc,
    ExpCommissionQuestions,
  },
  data: () => ({
    loadingWorkDocx: false,
    downloadDocx: false,
    objSummary: null,
    objRef: null,
    objCost: null,
    objAgencies: null,
    objGoPricing: null,
    objCommission: null,
    expertise: null,
    itemsMNN: [],
    analogMap: {},
  }),
  computed: {
    ...mapGetters([
      'storedPlpSigner',
      'storedPlp',
      'storedPlpId',
      'storedPlpMNN',
      'isManager',
      'plp_task_id',
    ]),

    mnn() {
      // из экспертизы или уже как есть в PLP - как резерв
      return this.expertise?.summary?.mnn || this.storedPlpMNN
    },

    getPresentation() {
      return this.checkPresentation
        ? 'Представление о ЛП готово'
        : 'Преставление о ЛП не готово!'
    },
    getPricing() {
      return this.checkRefPricing
        ? 'Информация о референтных странах готова'
        : 'Информация о референтных странах не готова!'
    },
    getCost() {
      return this.checkCost
        ? 'Информация о "Расчёт затрат" готова'
        : 'Информация о "Расчёт затрат" не готова!'
    },
    getAgencies() {
      return this.checkAgencies
        ? 'Информация о зарубежных агенств готова'
        : 'Информация о зарубежных агенств не готова!'
    },
    getGoPricing() {
      return this.checkGoPricing
        ? 'Выпуск в ГО, закупки, ценовая характеристика — готово'
        : 'Выпуск в ГО, закупки, ценовая характеристика — не готово!'
    },
    getCommission() {
      return this.checkCommission
        ? 'Вопросы для комиссии — готово'
        : 'Вопросы для комиссии — не готово!'
    },
    expertiseGoPricing() {
      return this.expertise?.[SUB_EX_GO_PRICING]
    },
    expertiseCommission() {
      return this.expertise?.[SUB_EX_COMMISSION]
    },
    checkPresentation() {
      return this.expertise?.summary
    },
    checkRefPricing() {
      return this.expertise?.ref
    },
    checkCost() {
      return this.expertise?.cost
    },
    checkAgencies() {
      return this.expertise?.agencies
    },
    checkGoPricing() {
      return !!this.expertiseGoPricing
    },
    checkCommission() {
      return !!this.expertiseCommission
    },
    checkFullExpertise() {
      return this.checkPresentation && this.checkRefPricing && this.checkCost
    },
    //Свойство, проверяющее каждое свойство отчета на его наличие
    getProperties() {
      return this.checkFullExpertise
    },
  },
  mounted() {
    this.loadReportData()
  },
  methods: {
    ...mapActions(['GET_PLP_REPORT', 'CREATE_ACTION_LOG']),
    ...mapMutations(['SET_ERROR']),

    async loadReportData() {
      this.loadingWorkDocx = true
      try {
        const plp_id = this.storedPlpId
        const { expertise } = await this.GET_PLP_REPORT([
          ...SUB_EXPERTISE_FOR_SUMMARY_REPORT,
          SUB_EX_ABOUT,
          SUB_EX_OTHER,
          SUB_EX_ASSESSMENT,
        ])

        this.expertise = expertise || {}
        if (!expertise.summary) {
          this.objSummary = {
            codes: ['PLP_SUBEX_VER_MODIFIED', 'PLP_SUBEX_VER_CREATED'],
            plp_id,
            ex_type_name: 'summary',
          }
        }
        if (!expertise.ref) {
          this.objRef = {
            codes: ['PLP_SUBEX_VER_MODIFIED', 'PLP_SUBEX_VER_CREATED'],
            plp_id,
            ex_type_name: 'ref',
          }
        }
        if (!expertise.agencies) {
          this.objAgencies = {
            codes: ['PLP_SUBEX_VER_MODIFIED', 'PLP_SUBEX_VER_CREATED'],
            plp_id,
            ex_type_name: 'agencies',
          }
        }
        if (!expertise.cost) {
          this.objCost = {
            codes: ['PLP_SUBEX_VER_MODIFIED', 'PLP_SUBEX_VER_CREATED'],
            plp_id,
            ex_type_name: 'cost',
          }
        }
        if (!expertise[SUB_EX_GO_PRICING]) {
          this.objGoPricing = {
            codes: ['PLP_SUBEX_VER_MODIFIED', 'PLP_SUBEX_VER_CREATED'],
            plp_id,
            ex_type_name: SUB_EX_GO_PRICING,
          }
        }
        if (!expertise[SUB_EX_COMMISSION]) {
          this.objCommission = {
            codes: ['PLP_SUBEX_VER_MODIFIED', 'PLP_SUBEX_VER_CREATED'],
            plp_id,
            ex_type_name: SUB_EX_COMMISSION,
          }
        }
      } catch (err) {
        this.SET_ERROR({
          head: 'Заключение',
          text: 'Ошибка загрузки данных документа.',
          err,
        })
      } finally {
        this.loadingWorkDocx = false
      }
    },
    getAlertType(value) {
      return value ? 'success' : 'warning'
    },
    getAlertIcon(value) {
      return value ? 'mdi-check' : undefined
    },
    beStrong(value) {
      return `<span class="font-weight-medium">${value ?? ''}</span>`
    },
    exportDocx() {
      this.downloadDocx = true
      try {
        const summary = this.expertise?.summary
        const plpRegionText = this.storedPlp?.region?.text || ''
        const doc = new Document({
          sections: [
            portraitSectionProps([
              ...createOneChapter(
                summary,
                this.expertise?.cost,
                this.expertiseGoPricing,
                {
                  other: this.expertise?.other,
                  plpRegionText,
                  assessment: this.expertise?.[SUB_EX_ASSESSMENT],
                }
              ),
            ]),
            portraitSectionProps([
              ...createTwoChapter(
                this.expertise?.ref,
                this.expertise?.about?.mnn || this.mnn || '',
                this.expertise?.about,
                this.expertise?.agencies
              ),
            ]),
            landscapeSectionProps([
              ...createThreeChapter(
                this.expertise?.cost,
                summary?.mnn || this.mnn || ''
              ),
            ]),
            portraitSectionProps([
              ...createApplicantAdditionalChapter(summary),
            ]),
            portraitSectionProps([
              ...createMkQualityChapter(summary),
            ]),
            portraitSectionProps([
              ...createFourChapter(this.expertiseCommission),
            ]),
          ],
        })
        Packer.toBlob(doc).then(blob => {
          const plp_id = this.storedPlpId
          //ЗАПИСЫВАЕМ В ЛОГ ВЫГРУЗКУ ОТЧЁТА
          this.CREATE_ACTION_LOG({
            code: 'SUMMARY_REPORT_SAVE',
            message: `Сгенерировано заключение представления для "${this.mnn}"`,
            data: { plp_id },
          })
          saveAs(
            blob,
            ensureDocxFileName(
              `Заключение представления для ${this.mnn} от ${this.getTimestamp()}`
            )
          )
        })

        return doc
      } catch (err) {
        this.SET_ERROR({
          head: 'Заключение',
          text: 'Ошибка формирования документа',
          err,
        })
        throw err
      } finally {
        this.downloadDocx = false
      }
    },
    getTimestamp() {
      const date = new Date()
      const addZero = v => (v.toString().length === 1 ? `0${v}` : v)
      const yyyy = date.getFullYear()
      const MM = addZero(date.getMonth() + 1)
      const dd = addZero(date.getDate())
      return `${dd}_${MM}_${yyyy}`
    },
  },
}
</script>

<style scoped>
.exp_icon {
  position: absolute;
  left: -40px;
  top: -5px;
  /*color: #5d9e52;*/
}
.exp_header_text {
  /*color: #5d9e52;*/
  position: absolute;
}
</style>
